import React, { useState, useEffect } from 'react';
import { Avatar, Button, Form, Tooltip } from 'antd';

import { useNavigate, useParams } from 'react-router-dom';
import { deleteArrayInArray, errorCatch, Field, GET, If, JSXMap, Model, POST, triggerInArray, updateArrayInArray, useAuth, useTranslateContext } from 'fennec-ui';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { PrinterOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import { getIndexColor, getIndexColorAlt, getIndexColorLighter } from '../../../../common/Tool';
import dayjs from 'dayjs';
import PredvzyatostSudiEvent from '../PredvzyatostSudiEvent';

const User = ({ user }) => {
	return (<div style={{
		border: "1px solid transparent",
		maxWidth: "208px",
		minWidth: "208px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "flex",
		justifyContent: "flex-start",
		gap: "5px",
		alignItems: "center"
	}}>
		<div style={{ backgroundColor: (user?.genderID === 1) ? "blue" : "red", width: "13px", height: "13px", lineHeight: "13px", borderRadius: "3px", textAlign: "center" }}>
			<Icofont icon='user' style={{ color: "white", fontSize: "8px", marginLeft: "1px" }} />
		</div>
		<div>{user?.lastname} {user?.firstname}</div>
	</div>)
}
// const TableWithParameters = (props) => {
//     const { color, onChange } = props;
//     const auth = useAuth();
//     const t = useTranslateContext();

//     const [editing, setEditing] = useState(false);

//     const [selectedDancers, setSelectedDancers] = useState([]);
//     const [team, setTeam] = useState([]);
//     const [selectedTeam, setSelectedTeam] = useState([]);

//     useEffect(() => {
//         if (command.dancerCommandCommand) {
//             setTeam(command.dancerCommandCommand || []);
//         }
//     }, [command]);

//     const append = React.useCallback(() => {
//         POST(auth, `/api/adddancercommand/command/${command.ID}`, selectedDancers,
//             ({ data }) => {
//                 setSelectedDancers((o) => deleteArrayInArray(o || [], data.map(m => m.eventUser)));
//                 onChange({
//                     ...command,
//                     dancerCommandCommand: updateArrayInArray(command.dancerCommandCommand || [], data)
//                 });
//             }, errorCatch);
//     }, [command, selectedDancers, team]);
//     const remove = React.useCallback(() => {
//         POST(auth, `/api/dropdancercommand`, selectedTeam,
//             ({ data }) => {
//                 setSelectedTeam((o) => deleteArrayInArray(o || [], selectedTeam));
//                 onChange({
//                     ...command,
//                     dancerCommandCommand: deleteArrayInArray(command.dancerCommandCommand || [], selectedTeam)
//                 });
//             }, errorCatch);
//     }, [command, selectedTeam]);
//     return (
//         <div className='command'>
//             {<div style={{
//                 paddingLeft: "10px",
//                 marginLeft: "2px",
//                 borderLeft: (color) ? `2px solid ${color}` : `2px solid rgba(190, 190, 190, 0.2)`
//             }}>
//                 <div style={{ paddingLeft: "8px" }}>
//                     {command?.city?.name && <span>г. {command?.city?.name},</span>} {command?.vk && <span>vk: {command?.vk}</span>}
//                 </div>
//                 {((!team || team.length == 0) && (!editing)) && <div style={{ padding: "10px 0px" }}>
//                     <Button
//                         onClick={() => setEditing(!editing)}
//                         className="onhover fade-in"
//                         type="text"
//                         style={{
//                             width: "100%",
//                             height: "60px",
//                             borderRadius: "4px",
//                             border: "1px dotted lightgray"
//                         }}>
//                         <div>
//                             <div style={{ fontSize: "18px" }}><Icofont icon="ui-add" style={{ fontSize: "12px" }} /> {t("Добавить танцоров")}</div>
//                             <div style={{
//                                 fontSize: "12px",
//                                 fontStyle: "italic",
//                                 color: "rgba(0, 0, 0, 0.65)"
//                             }}>{t("В этой команде пока нет танцоров")}</div>
//                         </div>
//                     </Button>
//                 </div>}

//                 {((team && team.length > 0) || (editing)) && <div>
//                     <div style={{ padding: "10px 0px 0px 0px" }}>
//                         <div className='bg bg-grey button pointer' onClick={() => setEditing(!editing)}>
//                             {(editing) ? t("Завершить редактирование") : t("Редактировать танцоров")}
//                         </div>
//                     </div>
//                     <div style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         gap: 5,
//                         padding: "10px 0px"
//                     }}>
//                         {(editing === true) && <div style={{ flex: 1 }}>
//                             <CollectionPanel
//                                 data={deleteArrayInArray(dancers, team.map(t => t.eventUser))}
//                                 height="400px"
//                                 // countFunctions={{
//                                 //     male: (e) => e.user.genderID === 1,
//                                 //     female: (e) => e.user.genderID === 2,
//                                 // }}
//                                 // title={({ count }) => <DancerCountByGender title={t("Все танцоры мероприятия")} male={count.male} female={count.female} style={{ padding: "3px 0px" }} />}
//                                 renderItem={(e, idx) => (
//                                     <DancerByGender
//                                         onClick={() => setSelectedDancers((o) => triggerInArray(o, e))}
//                                         gender={(item) => item.user.genderID}
//                                         item={e}
//                                         key={e.ID} name={`${e.user.lastname} ${e.user.firstname}`} className="pointer" selected={selectedDancers?.find(x => x.ID === e.ID) !== undefined}
//                                     />
//                                 )}
//                             />
//                         </div>}
//                         {(editing === true) && <div style={{ flex: 0, alignSelf: "center", padding: "0px 10px", display: "flex", flexDirection: "column", justifyContent: "center", gap: 5 }}>
//                             <Button onClick={append}><Icofont icon="rounded-right" /></Button>
//                             <Button onClick={remove}><Icofont icon="rounded-left" /></Button>
//                         </div>}
//                         <div style={{ flex: 1 }}>
//                             <CollectionPanel
//                                 data={team}
//                                 height="400px"
//                                 // countFunctions={{
//                                 //     male: (e) => e.eventUser.user.genderID === 1,
//                                 //     female: (e) => e.eventUser.user.genderID === 2,
//                                 // }}
//                                 // title={({ count }) => <DancerCountByGender title={`Танцоры команды`} male={count.male} female={count.female} style={{ padding: "3px 0px" }} />}
//                                 renderItem={(e, idx) => (
//                                     <DancerByGender
//                                         onClick={() => {
//                                             if (editing) {
//                                                 setSelectedTeam((o) => triggerInArray(o, e));
//                                             }
//                                         }}
//                                         gender={(item) => item.eventUser.user.genderID}
//                                         item={e}
//                                         key={e.ID} name={`${e.eventUser.user.lastname} ${e.eventUser.user.firstname}`}
//                                         className={(editing) ? "pointer" : ""}
//                                         selected={(editing) ? selectedTeam?.find(x => x.ID === e.ID) !== undefined : false}
//                                     />
//                                 )}
//                             />
//                         </div>
//                     </div>
//                 </div>}

//             </div>}
//         </div >
//     )
// }
export default function PredvzyatostSudiZaPeriod(props) {
	let navigate = useNavigate();

	const { auth } = props;
	// const { eventid } = useParams();
	const t = useTranslateContext();
	const [loading, setLoading] = useState(false);

	const [meropriyatieID, setMeropriyatieID] = useState();
	const [object, setObject] = useState({
		// dateStart: dayjs('2023-01-01'),
		// dateEnd: dayjs('2024-01-01'),
		// judgeID: 756,
		// dancerIdList: [3823, 3578, 3499, 1975]
	});

	// const dateStart = dayjs('2023-01-01');
	// const dateEnd = dayjs('2024-01-01');
	// const judgeID = 756;
	// const dancerIdList = [3823, 3578, 3499, 1975];

	const [judges, setJudges] = useState()
	const [dancerList, setDancerList] = useState()
	const [data, setData] = useState()

	// judge
	// psItogPoMeropriyatiyu
	// meropriyatiya
	// dancerList

	useEffect(() => {
		// setLoading(true);

		// if (!judges && object?.dateStart && object?.dateEnd) {
		// 	POST(auth, `/api/report/predvzyatost-sudi-list-sudey`, {
		// 		dateStart: object?.dateStart,
		// 		dateEnd: object?.dateEnd,
		// 	}, ({ data }) => {
		// 		setJudges(data)
		// 		setDancerList();
		// 		setData()
		// 		setLoading(false);
		// 	}, (err) => errorCatch(err, () => setLoading(false)));
		// }

		// if ((!dancerList || !dancerList.length) && object?.dateStart && object?.dateEnd && object?.judgeID) {
		// 	POST(auth, `/api/report/predvzyatost-sudi-list-tantsorov`, {
		// 		dateStart: object?.dateStart,
		// 		dateEnd: object?.dateEnd,
		// 		judgeID: object?.judgeID,
		// 	}, ({ data }) => {
		// 		setDancerList(data)
		// 		setData()
		// 		setLoading(false);
		// 	}, (err) => errorCatch(err, () => setLoading(false)));
		// }

		if (object?.dateStart && object?.dateEnd && object?.judgeID && object?.dancerIdList && object?.dancerIdList.length) {
			POST(auth, `/api/report/predvzyatost-sudi-za-period`, {
				dateStart: object?.dateStart,
				dateEnd: object?.dateEnd,
				judgeID: object?.judgeID,
				dancerIdList: object?.dancerIdList,
			}, ({ data }) => {
				setData(data)
				setLoading(false);
			}, (err) => errorCatch(err, () => { setData(); setLoading(false) }));
		}

		form.resetFields()
	}, [auth, object]);

	const apply = (values) => {
		setObject(values)
	}

	const ref = useRef(null)

	const [form] = Form.useForm()
	const fdateStart = Form.useWatch('dateStart', { form, preserve: true });
	const fdateEnd = Form.useWatch('dateEnd', { form, preserve: true });
	const fjudgeID = Form.useWatch('judgeID', { form, preserve: true });
	const fdancerIdList = Form.useWatch('dancerIdList', { form, preserve: true });

	useEffect(() => {
		if (fdateStart && fdateEnd) {
			POST(auth, `/api/report/predvzyatost-sudi-list-sudey`, {
				dateStart: fdateStart,
				dateEnd: fdateEnd,
			}, ({ data }) => {
				setJudges(data)
				setDancerList();
				setData()
				setLoading(false);
			}, (err) => errorCatch(err, () => setLoading(false)));
		}
		setObject(old => ({ ...old, dateStart: fdateStart, dateEnd: fdateEnd, judgeID: undefined, dancerIdList: undefined }))
	}, [fdateStart, fdateEnd])

	useEffect(() => {
		if (object?.dateStart && object?.dateEnd && fjudgeID) {
			POST(auth, `/api/report/predvzyatost-sudi-list-tantsorov`, {
				dateStart: object?.dateStart,
				dateEnd: object?.dateEnd,
				judgeID: fjudgeID,
			}, ({ data }) => {
				setDancerList(data)
				setData()
				setLoading(false);
			}, (err) => errorCatch(err, () => setLoading(false)));
		}
		setObject(old => ({ ...old, judgeID: fjudgeID, dancerIdList: undefined }))
	}, [fjudgeID])

	useEffect(()=>{
		setData()
		setMeropriyatieID()
	}, [fdancerIdList])

	return (
		<div>
			{/* <TableWithParameters /> */}
			<div style={{ display: "flex", justifyContent: "start", padding: "15px" }}>
				<div style={{ display: "flex", justifyContent: "center", flexDirection: "column", width: "500px" }}>

					<Form
						form={form}
						onFinish={apply}
						// onFieldsChange={(changedFields, allFields) => { console.log(changedFields, allFields); }}
						labelAlign={"left"}
						layout={"vertical"}
						initialValues={object}
					>
						<Form.Item label="Дата начала" name="dateStart"
							rules={[{ required: true, message: 'Пожалуйста, укажите дату начала!' }]}
						>
							<Field auth={auth} item={{ type: "date", label: "Дата начала", name: "dateStart" }} />
						</Form.Item>
						<Form.Item label="Дата окончания" name="dateEnd"
							rules={[{ required: true, message: 'Пожалуйста, укажите дату окончания!' }]}
						>
							<Field auth={auth} item={{ type: "date", label: "Дата окончания", name: "dateEnd" }} />
						</Form.Item>
						{judges && <Form.Item label="Судья"
							name="judgeID"
							rules={[{ required: true, message: 'Пожалуйста, укажите судью!' }]}
						>
							<Field
								auth={auth}
								item={{
									type: "object",
									label: "Судья",
									name: "judgeID",
									relation: {
										displayString: ((item) => { return item.lastname + " " + item.firstname; }),
										display: (item) => {
											return <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
												<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
													{item?.genderID == 1 && <Avatar shape="square" size={16} icon={<Icofont icon="user" />} style={{ backgroundColor: "blue" }} />}
													{item?.genderID == 2 && <Avatar shape="square" size={16} icon={<Icofont icon="user" />} style={{ backgroundColor: "red" }} />}
												</div>
												<div>{item.lastname} {item.firstname}</div>
											</div>
										},
										reference: { data: judges, property: "ID" },
										type: "many-one",
									}
								}}
							/>
						</Form.Item>}
						{dancerList && <Form.Item label="Танцоры"
							name="dancerIdList"
							rules={[{ required: true, message: 'Пожалуйста, укажите танцоров!' }]}
						>
							<Field
								auth={auth}
								item={{
									type: "object",
									filterType: "group",
									label: "Танцоры",
									name: "dancerIdList",
									relation: {
										displayString: ((item) => { return item.lastname + " " + item.firstname; }),
										display: (item) => {
											return <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
												<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
													{item?.genderID == 1 && <Avatar shape="square" size={16} icon={<Icofont icon="businessman" />} style={{ backgroundColor: "blue" }} />}
													{item?.genderID == 2 && <Avatar shape="square" size={16} icon={<Icofont icon="businesswoman" />} style={{ backgroundColor: "red" }} />}
												</div>
												<div>{item.lastname} {item.firstname}</div>
											</div>
										},
										reference: { data: dancerList, property: "ID" },
										type: "many-one",
									}
								}}
							/>
						</Form.Item>}
					</Form>
					<Button onClick={form.submit}>Применить</Button>
				</div>
			</div>
			<div style={{ display: "flex", justifyContent: "right", padding: "15px 20px" }} >
				<ReactToPrint
					trigger={() => {
						// NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
						// to the root node of the returned component as it will be overwritten.
						return (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /> Печать</Button>)
					}}
					content={() => ref.current}
				/>
			</div>
			{(data?.meropriyatiya) && <div className="report" style={{ padding: "0 25px" }} ref={ref}>
				{(data?.judge) && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "16px", marginBottom: "20px" }}>
					<div>Судья: {data.judge?.lastname} {data.judge?.firstname}</div>
					<div>Период: {dayjs(object?.dateStart).format("DD.MM.YYYY")} - {dayjs(object?.dateEnd).format("DD.MM.YYYY")}</div>
				</div>}
				<div className='scrollable' style={{ backgroundColor: "white" }}>
					<table className="table" style={{ fontSize: "13px" }}>
						<thead>
							<tr>
								<th className={`wrap fixed`} style={{ minWidth: "210px", backgroundColor: "white" }}>
									<div className='bg bg-grey dark-1'>Участник</div>
								</th>
								<th className="wrap fixed" style={{ left: "210px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
									<div className='bg bg-orange dark-5 border-orange' style={{ fontWeight: "bold" }}>Среднее арифм.</div>
								</th>
								<th className="wrap fixed" style={{ left: "310px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
									<div className='bg bg-orange dark-5 border-orange' style={{ fontWeight: "bold" }}>Среднее по дисперсиям</div>
								</th>
								{JSXMap(data?.meropriyatiya, (meropriyatie, cidx) => {
									let color = getIndexColorLighter(meropriyatie?.ID || 1, 0.25)
									return (<th className="wrap" style={{ fontWeight: "300" }} key={cidx}>
										<div className="bg pointer" onClick={(e) => {
											setMeropriyatieID(meropriyatie?.ID);
											console.log("click", meropriyatie?.ID);
											// navigate(`/app/reports/predvzyatost-sudi/event`);
										}} style={{ backgroundColor: color }}>
											<span>{meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ({meropriyatie?.mestoProvedeniya?.name})
										</div>
									</th>)
								})}
							</tr>
						</thead>
						<tbody style={{ fontSize: "12px" }}>
							{JSXMap(data?.dancerList || [], (dancerItem, cidx) => {
								let summ = 0;
								let summDisperion = 0;
								// let summDisperionV2 = 0;
								let count = 0;
								for (let i = 0; i < data?.psItogPoMeropriyatiyu?.length; i++) {
									const el = data.psItogPoMeropriyatiyu[i];
									if (el?.tantsor?.userID == dancerItem?.ID) {
										summ += el.srednee;
										summDisperion += el.sredneePoDispersiyam;
										count++
									}
								}

								let avg = 0;
								let avgDispersion = 0;
								if (count > 0) {
									avg = Math.round((summ / count) * 100) / 100;
									avgDispersion = Math.round((summDisperion / count) * 100) / 100;
								}

								// for (let i = 0; i < data?.psItogPoMeropriyatiyu?.length; i++) {
								// 	const el = data.psItogPoMeropriyatiyu[i];
								// 	if (el?.tantsor?.userID == dancerItem?.ID) {
								// 		summDisperionV2 += Math.pow((el.srednee - avg), 2);
								// 	}
								// }

								// let avgDispersionV2 = 0;
								// if (count > 0) {
								// 	avgDispersionV2 = Math.round((summDisperionV2 / count) * 10000) / 10000;
								// }

								return (<tr key={cidx}>
									<td className={`fixed`} style={{ minWidth: "210px", backgroundColor: "white" }}>
										<User user={dancerItem} />
									</td>
									<td className={`fixed`} style={{ left: "210px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
										<div className="fixed bg bg-orange dark-1" style={{ fontWeight: "bold" }}>
											{avg}
										</div>
									</td>
									<td className={`fixed`} style={{ left: "310px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
										<div className="fixed bg bg-orange dark-1" style={{ fontWeight: "bold" }}>
											{avgDispersion}
										</div>
									</td>
									{JSXMap(data?.meropriyatiya, (meropriyatie, cidx) => {
										let itemCell = data?.psItogPoMeropriyatiyu?.find((el) => {
											return el?.tantsor?.userID == dancerItem?.ID &&
												el?.meropriyatieID == meropriyatie?.ID
										})
										let color = getIndexColorLighter(meropriyatie?.parametrKriteriya?.ID || 1, 0.14)
										return (<td className="wrap" style={{ fontWeight: "300" }} key={cidx}>
											<div className="bg bg-grey" style={{ backgroundColor: color }}>
												{itemCell?.srednee}
											</div>
										</td>)
									})}
								</tr>)
							})}
						</tbody>
					</table>
				</div>
				{(meropriyatieID && object?.judgeID && object?.dancerIdList) && <div style={{ marginTop: "25px" }}>
					<PredvzyatostSudiEvent auth={auth} meropriyatieID={meropriyatieID} judgeID={object?.judgeID} dancerIdList={object?.dancerIdList} />
				</div>}
			</div>}
		</div >);
}
